"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRetry = void 0;
const MAX_RETRIES = 10;
function withRetry(func, args, maxRetries = MAX_RETRIES) {
    return __awaiter(this, void 0, void 0, function* () {
        let retries = 0;
        while (true) {
            try {
                const result = yield func(...args);
                return result;
            }
            catch (error) {
                retries++;
                if (retries > maxRetries) {
                    throw new Error(`Max retries exceeded when executing ${func.name.toLowerCase()}: ${error}`);
                }
            }
        }
    });
}
exports.withRetry = withRetry;
//# sourceMappingURL=index.js.map